import React from 'react';
import PageHero from '../../components/ui-shree/PageHero';
import ManufacturerShell from '../../components/ManufacturerPortal';

const ManufacturerPage = () => (
  <div data-testid="manufacturer-page">
    <PageHero
      overline="Atelier · Manufacturer Portal"
      title={
        <>
          The <em className="text-[#90B0BF]">factory floor</em>,
          <br />
          on chain.
        </>
      }
      subtitle="Anti-fraud workflows for the Atelier. Verify the tamper-seal on every drum that arrives from India before it ever touches a batch — and commit each opened drum to its production lot, on chain."
      testId="manufacturer-hero"
    />
    <section className="px-6 md:px-12 pb-32">
      <div className="max-w-[1400px] mx-auto">
        <ManufacturerShell />
      </div>
    </section>
  </div>
);

export default ManufacturerPage;
